import React, { Component, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../style/common/edit.scss";
import Loading from "./Loading";
import * as UploadImgAPI from "../../apis/UploadImgAPI";
import ApiEndpointConstants, {
  BASE_URL,
} from "../../constants/ApiEndpointConstants";
import axios from "axios";

class RichTextEditor extends Component {
  // const [editorContent, setEditorContent] = useState("");
  constructor(props) {
    super(props);

    this.state = {
      editorContent: props.value || "",
      imgArr: [],
      loadingShow: false,
    };
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    // this.selectLocalImage = this.selectLocalImage.bind(this);
    this.insertToEditor = this.insertToEditor.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  quillRef = React.createRef();

  modules = {
    toolbar: {
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image", "video"],
        ["clean"],
      ],
      handlers: {
        image: this.selectLocalImage.bind(this),
      },
    },
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ editorContent: nextProps.value });
    }
  }

  handleEditorChange(content, delta, source, editor) {
    this.setState({ editorContent: content });
    // console.error(content);
  }

  uploadImage(file, imgIndex) {
    let { imgArr } = this.state;
    const _that = this;
    var formData = new FormData();
    [file].forEach((fileInfo, index) => {
      // if (index > 0) return;
      // let reads = new FileReader();
      // reads.readAsDataURL(fileInfo);
      //读取选中图片，并转成DataURL格式
      // reads.onload = function (e) {
      //   const imgUrl = this.result;
      //   // render加载时赋值
      //   console.log(this.result);
      //   _that.toggleShow();
      //   UploadImgAPI.upload(imgUrl)
      //     .then((res) => {
      //       _that.toggleShow();
      //       console.log(res);
      //       let url = res.data.data.fullurl;
      //       console.log(url);
      //       _that.insertToEditor(url);
      //       // if (imgArr[index] !== undefined) {
      //       //   imgArr[index].img = url;
      //       // } else {
      //       //   imgArr.push({ img: url });
      //       // }
      //       imgArr[imgIndex + index] = url;
      //       _that.setState({ imgArr });
      //       e.target.value = "";
      //       // console.error(imgArr);
      //     })
      //     .catch(() => {
      //       _that.toggleShow();
      //       e.target.value = "";
      //     });
      // };
      // reads.readAsDataURL(fileInfo);
      formData.append("file", fileInfo);
      console.log(formData);
      console.log(fileInfo);
      axios({
        url: BASE_URL + ApiEndpointConstants.UPLOAD,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log("连上了---------");
          let url = res.data.data.fullurl;
          _that.insertToEditor(url);
          console.log(url);
          imgArr[imgIndex + index] = url;
          _that.setState({ imgArr });
          file = "";
          // console.error(imgArr);
        })
        .catch((err) => {
          // return reject(err);
        });
    });
  }

  /*
  handleInsertImg() {
        const { imgActions } = this.props;
        const quillEditor = this.refEditor && this.refEditor.current.getEditor();
        const _this = this;
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        input.onchange = async () => {
            [...input.files].forEach((fileInfo, index) => {
                let reads = new FileReader();
                reads.readAsDataURL(fileInfo);
                reads.onload = function (e) {
                    const imgUrl = this.result
                    _this.toggleLoading();
                    imgActions && imgActions.uploadImgToGetUrl(imgUrl)
                        .then(url => {
                            _this.toggleLoading();
                            const range = quillEditor.getSelection();
                            console.error(range);
                            quillEditor.insertEmbed(range.index, 'image', url); // 插入图片
                        })
                        .catch(() => {
                            _this.toggleLoading();
                            // event.target.value = '';
                        });
                }
            });
        };
    }
  */

  selectLocalImage() {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    document.body.appendChild(input); // 将 input 添加到 DOM 中
    input.style.display = "none"; // 隐藏 input

    input.click();
    input.onchange = () => {
      const files = input.files;
      if (files.length > 0) {
        this.uploadImage(files[0]);
      }
      document.body.removeChild(input); // 使用完毕后移除 input
    };
  }

  insertToEditor(url) {
    if (!url) {
      console.error("URL is undefined");
      return;
    }

    const editor = this.quillRef.current.getEditor();
    const range = editor.getSelection(true);
    if (range) {
      editor.insertEmbed(range.index, "image", url);
      // quillEditor.insertEmbed(range.index, 'image', url);
    } else {
      console.warn("No position selected in the editor");
    }
  }

  handleChange = (editorHtml) => {
    this.setState({ editorHtml });
  };

  render() {
    const { editorContent, loadingShow } = this.state;
    return (
      <React.Fragment>
        <Loading loadingShow={loadingShow} />
        <div className="rich-text-editor">
          <ReactQuill
            ref={this.quillRef}
            value={editorContent || ""}
            onChange={this.handleEditorChange}
            modules={this.modules} // 使用类属性中定义的 modules
            placeholder="请输入内容"
          />
        </div>
      </React.Fragment>
    );
  }
}

export default RichTextEditor;
